/*
* Hook Add quantity controls -/+
*/
document.addEventListener("DOMContentLoaded", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragments_refreshed", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragments_ajax_error", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragment_refresh", pdw_wc_qty_init);
jQuery(document.body).on("wc_fragments_loaded", pdw_wc_qty_init);
jQuery(document.body).on("update_checkout", pdw_wc_qty_init);
jQuery(document.body).on("updated_wc_div", pdw_wc_qty_init);
jQuery(document.body).on("applied_coupon", pdw_wc_qty_init);
jQuery(document.body).on("removed_coupon", pdw_wc_qty_init);

/*
* Hook Refresh WooCommerce Ajax Fragment
*/
//Fix minicart count with wp-rocket
document.addEventListener("DOMContentLoaded", pdw_wc_fragment_refresh);
document.addEventListener("load", pdw_wc_fragment_refresh);
jQuery(document.body).on("added_to_cart", pdw_wc_fragment_refresh);

/*
* Hook on ajax add to cart
*/
jQuery(document.body).on("added_to_cart", pdw_wc_open_cart);

/*
* Add quantity controls -/+
 */
function pdw_wc_qty_init() {
    let inputQuantities = document.querySelectorAll('.quantity');
    inputQuantities.forEach((el) => {
        // Évite les doublons : le init est rappelé sur plusieurs events WC (fragments…).
        if (el.classList.contains('pdw-wc-qty-ready')) {
            return;
        }
        let inputQty = el.querySelector('input.qty');
        if (!inputQty) {
            return;
        }
        // Bouton « Mettre à jour le panier » : présent uniquement sur la page panier.
        let syncCart = () => {
            inputQty.dispatchEvent(new window.Event('change', {bubbles: true}));
            let updateBtn = document.querySelector('button[name="update_cart"]');
            if (updateBtn) {
                updateBtn.click();
            }
        };
        let qtyDown = document.createElement('span');
        let qtyUp = document.createElement('span');
        qtyDown.addEventListener('click', () => {
            inputQty.stepDown();
            syncCart();
        });
        qtyDown.classList.add('pdw-wc-qty-down');
        qtyUp.addEventListener('click', () => {
            inputQty.stepUp();
            syncCart();
        });
        qtyUp.classList.add('pdw-wc-qty-up');
        el.appendChild(qtyDown);
        el.appendChild(qtyUp);
        el.classList.add('pdw-wc-qty-ready');
    });
}

/*
* Open minicart
*/
function pdw_wc_open_cart() {
    document.querySelectorAll('.pdw-wc-minicart-link')[0].click();
}

/*
* Refresh WooCommerce Ajax Fragment
*/
function pdw_wc_fragment_refresh(ev) {
    jQuery(document.body).trigger('wc_fragment_refresh');
}